import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'app/services/api';
import { Observable, Subscription } from 'rxjs';
import * as lodash from 'lodash';
import { element } from '@angular/upgrade/src/common/angular1';
import { AngularFireDatabase } from 'angularfire2/database';


@Component({
  selector: 'app-tournament-manager-individual',
  templateUrl: './tournament-manager-individual.component.html',
  styleUrls: ['./tournament-manager-individual.component.scss']
})
export class TournamentManagerIndividualComponent implements OnInit {
  @Input() tournamentId: any;
  @Input() startType: any;
  @Input() createGroupsEvent: Observable<void>;
  @Input() fillGroupsEvent: Observable<void>;
  @Input() resetGroupsEvent: Observable<void>;
  @Output() onTabChange = new EventEmitter();
  @Output() ongroupCreatedChange = new EventEmitter();
  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
  ) { }
  public unallocatedEntriesOriginal = []
  public unallocatedEntries = [];
  public groups = [];
  public tournament: any;
  public val = 500;
  public createGroupsEventSubscription: Subscription;
  public fillGroupsEventSubscription: Subscription;
  public resetGroupsEventSubscription: Subscription;
  public startTypes = [];
  public teeInterval = 10;
  public groupSize = 4;
  public startHoles = [];
  public missing = [];
  public unallocatedLength = 0;
  public openRemoveUnallocatedEntriesModal = false;
  public imageLoader = false;

  isDropAllowed = (dragData: any) => {
    // Resolves to true or false after 1 second
    return Observable.of(dragData > this.val).delay(1000);
  }

  async removeAllGroups(result) {
    this.imageLoader = true;
    for (let i = 0; i < this.groups.length; i++)
    {
      let groupIndex = i;
      if (this.groups.length == 1) // if its last group
      {
        this.tournament.isGroupCreated = false;
        await this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/isGroupCreated`).set(false);
      }
      let group = this.groups[groupIndex];
      let players = group.players ? group.players : [];
      players.forEach(async event => {
        let entry = event;
        await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${entry.teamId}/groups/${entry.key}`).set(null);
      });
      await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${group.groupId}`).set(null);
    }
    await this.init();
    this.imageLoader = false;
  }

  onClickRemoveUnallocatedEntries(event)
  {
    this.onTabChange.emit(2);
        this.openRemoveUnallocatedEntriesModal = false;
    $("#RemoveUnallocatedEntriesModal").modal('hide');
  }


  async createGroup(event) {
    this.imageLoader = true;
    let group;

            // group.noPlayer = [];
            // for (let i = 0; i < (this.groupSize - group.players.length); i++)
            // {
            //   group.noPlayer.push(0);
            // }


    if(this.missing.length > 0)
    {
      let val = this.missing.shift()-1;
      let starTime = this.tournament.startTime.split(":");
      let hours = +starTime[0];
      let mins = +starTime[1];
      let oldDateObj = new Date();
      oldDateObj.setHours(hours);
      oldDateObj.setMinutes(mins);
      var newDateObj = new Date();
      newDateObj.setHours(hours);
      newDateObj.setMinutes(mins);
      let minutes = (val) * (+this.teeInterval);
      newDateObj.setTime(oldDateObj.getTime() + (minutes * 60 * 1000));
      let hole: number;
      if (this.startType == 3) // shotgun
      {
        let lenn = this.startHoles.length;
        hole = (val%lenn)+1
      }
      else if (this.startType == 2) //1 and 10
      {
        let numberOFGroups = 0;
        if(this.unallocatedEntriesOriginal.length)
        {
          numberOFGroups = Math.ceil(this.unallocatedEntriesOriginal.length/this.groupSize);
        }
        if (val   > (numberOFGroups / 2)) {                                                             /// len
          hole = 10;
        } else hole = 1;
      }
      else { //1 or 10
        hole = this.startType;
      }
      group = {
          name: "Group "+(val   + 1),                                                                   /// len
          hole: hole,
          time: ("0" + (newDateObj.getHours())).slice(-2)+":"+("0" + (newDateObj.getMinutes())).slice(-2),
          players: [

        ]
      }
    }
    else {
      let starTime = this.tournament.startTime.split(":");
      let hours = +starTime[0];
      let mins = +starTime[1];
      let oldDateObj = new Date();
      oldDateObj.setHours(hours);
      oldDateObj.setMinutes(mins);
      var newDateObj = new Date();
      newDateObj.setHours(hours);
      newDateObj.setMinutes(mins);
      let minutes = (this.groups.length) * (+this.teeInterval);
      newDateObj.setTime(oldDateObj.getTime() + (minutes * 60 * 1000));
      let hole: number;
      if (this.startType == 3) // shotgun
      {
        let lenn = this.startHoles.length;
        hole = (this.groups.length%lenn)+1
      }
      else if (this.startType == 2) //1 and 10
      {
        let numberOFGroups = 0;
        if(this.unallocatedEntriesOriginal.length)
        {
          numberOFGroups = Math.ceil(this.unallocatedEntriesOriginal.length/this.groupSize);
        }
        if (this.groups.length   > (numberOFGroups / 2)) {                                                             /// len
          hole = 10;
        } else hole = 1;
      }
      else {
        hole = this.startType;
      }
      group = {
          name: "Group "+(this.groups.length   + 1),                                                                   /// len
          hole: hole,
          time: ("0" + (newDateObj.getHours())).slice(-2)+":"+("0" + (newDateObj.getMinutes())).slice(-2),
          players: [

        ]
      }
    }
    let key = this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}`).push().key;
    let g = await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${key}`).set(group);

    // await this.init();
    await this.fetchGroups();
    this.imageLoader = false;
  }

  ngOnDestroy() {
    this.createGroupsEventSubscription.unsubscribe();
    this.fillGroupsEventSubscription.unsubscribe();
    this.resetGroupsEventSubscription.unsubscribe();
  }

  onHoleChange(event, groupIndex)
  {
    let group = this.groups[groupIndex];
    if(!event)
    {
      alert("Please enter valid hole number");
    }
  }

  onTimeChange(event, groupIndex)
  {
    let group = this.groups[groupIndex];
    if(!event)
    {
      alert("Please enter valid time");
    }
  }

  async updateGroup(groupIndex) {

    let group = this.groups[groupIndex];
    let groupId = group.groupId;
    delete group.groupId;
    delete group.noPlayer;
    let players : any = {};
    group.players.forEach(player => {
      players[""+player.key] = true;
    });
    group.players = players
    this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${groupId}`).update(group);
  }

  async onRemoveEntryFromGroup(event, groupIndex, entryIndex)
  {
    this.imageLoader = true;
    let entry;
    if (groupIndex > -1 && entryIndex > -1) {
      entry = this.groups[groupIndex].players[entryIndex];
      this.unallocatedEntries.push(entry);
      this.groups[groupIndex].players.splice(entryIndex, 1);
    }
    this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${entry.teamId}/groups/${entry.key}`).set(null);
    await this.updateGroup(groupIndex);
    await this.init();
     this.imageLoader = false;
  }

  onRemoveUnallocatedPlayer(event, player) {
    this.openRemoveUnallocatedEntriesModal = true;
    $("#RemoveUnallocatedEntriesModal").modal('show');
  }

  async onRemoveGroup(event, groupIndex) {

    // remove all users entries for that group put them in unassigned entries
    // then remove group
    this.imageLoader = true
    if(this.groups.length == 1) // if its last group
    {
      this.tournament.isGroupCreated = false;
      await this.fireDatabase.database.ref(`tournaments/${this.tournamentId}/isGroupCreated`).set(false);
      this.ongroupCreatedChange.emit(false);
    }
    let group = this.groups[groupIndex];
    let players = group.players ? group.players : [];
    players.forEach(async event => {
      let entry = event;
      await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${entry.teamId}/groups/${entry.key}`).set(null);
    });
    await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${group.groupId}`).set(null);
    await this.fetchGroups();
    this.imageLoader = false
  }
  async fetchGroups() {
  let groups = await this.apiService.object(
      `/tournament-groups/${this.tournamentId}`
  );
    let fetchGroupName = [];
    let max = -1;
    this.groups = [];
    if(groups.$exists())
    {
      for (let groupId in groups)
      {
        let group = groups[groupId];
        let groupNumber= +group.name.slice(6);
        if(max < groupNumber) max = groupNumber;
        fetchGroupName.push(groupNumber);
        Object.assign(group, { groupId: groupId });
        if (!group.players)
        {
          Object.assign(group, { players: [] });
          group.noPlayer = [];
          for (let i = 0; i < (this.groupSize - 0); i++)
          {
            group.noPlayer.push(0);
          }
        } else {
          let players = []
          lodash.forEach(group.players, async(player, key) => {
            this.unallocatedEntriesOriginal.forEach(async entry => {
              if (key == entry.key)
              {
                Object.assign(group, {groupId: group.groupId })
                players.push(entry)
              }
            });
          });
          group.players = players
          if(group.players.length < this.groupSize)
          {
            group.noPlayer = [];
            for (let i = 0; i < (this.groupSize - group.players.length); i++)
            {
              group.noPlayer.push(0);
            }
          }
        }
        this.groups.push(group);
      }

      let avail = [];
      for (let i = 0; i < max; i++)
      {
        avail.push(i + 1);
      }

      this.missing = avail.filter(x => fetchGroupName.indexOf(x) === -1);
    }
  }

  async fillGroups(type) {
    if(this.groups.length==0) {
      alert("Atleast create one group")
      return
    }
    this.imageLoader = true;
    if (type != 1) {
      alert("not available right now");
    }
    else // only random
    {
      let entries = this.unallocatedEntries.filter(result => {
        return !result.groupId
      });
      for (let i = 0; i < this.groups.length; i++)
      {
        let teamsToFill = this.groupSize - (this.groups[i].players && this.groups[i].players.length ? this.groups[i].players.length : 0);
        for(let j = 0; j < teamsToFill; j++)
        {

          let player = entries.shift();
          if(player)
          {
            let groupIndex = i;
            if(this.groups[groupIndex].players && this.groups[groupIndex].players.length < this.groupSize)
            {
              this.groups[groupIndex].players.push(player);
              await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${player.teamId}/groups/${player.key}`).set(this.groups[groupIndex].groupId);
              let group = this.groups[groupIndex];
              let groupId = group.groupId;
              await this.fireDatabase.database.ref(`/tournament-groups/${this.tournamentId}/${groupId}/players/${player.key}`).set(true); // manage remove or add entries from here
            }
             else {
            }
          }
        }
      }
    }

    await this.init()
    this.imageLoader = false;
  }

  async createDefaultGroups(data) {
    this.groupSize = +data.groupSize;
    this.startType = +data.startType;
    this.teeInterval = data.teeInterval;
    this.tournament.isGroupCreated = true;
    let numberOFGroups = 0;

    if(this.unallocatedEntriesOriginal.length)
    {
      numberOFGroups = Math.ceil(this.unallocatedEntriesOriginal.length/data.groupSize);
    }
    for (let i = 0; i < numberOFGroups; i++){
      await this.createGroup(null);
    }
  }

  async ngOnInit() {
    this.createGroupsEventSubscription = this.createGroupsEvent.subscribe(async (result) => {
      await this.createDefaultGroups(result);
    });

    this.fillGroupsEventSubscription = this.fillGroupsEvent.subscribe(async (result) => {
      this.fillGroups(result);
    });

    this.resetGroupsEventSubscription = this.resetGroupsEvent.subscribe(async (result) => {
      this.tournament.isGroupCreated = false;
      await this.removeAllGroups(result);
    });

    this.tournament = await this.apiService.object(
      `/tournaments/${this.tournamentId}`
    );
    //group creation data
    switch (this.tournament.holesPart) {
      case 1:
        for (let i = 0; i < 9; i++) {
          this.startHoles.push(i + 1);
        }
        this.startType = 1;

        break;
      case 2:
        for (let i = 9; i < 18; i++) {
          this.startHoles.push(i + 1);
        }
        this.startType = 10;
        break;
      default:
        for (let i = 0; i < 18; i++) {
          this.startHoles.push(i + 1);
        }
        this.startType = 1;
        break;
    }

    this.groupSize = +this.tournament.groupSize ?  +this.tournament.groupSize: 4;
    this.startType = +this.tournament.startType ? +this.tournament.startType: this.startType;
    this.teeInterval = this.tournament.teeInterval ? this.tournament.teeInterval: 10 ;

    
    await this.init();
  }

  async init() {
    let uniquePlayers = new Map();
    let tournamentPlayers = await this.apiService.object(`/tournament-fixtures/${this.tournamentId}`);
    if(tournamentPlayers.$exists()) {
      for(let teamKey in tournamentPlayers)
      {
        let team = tournamentPlayers[teamKey];
        let groups = team.groups ? team.groups : {};
        let players = team.players ? team.players : [];
        let manualPlayers = team.manual_players ? team.manual_players : [];
        for (let manualPlayerKey in manualPlayers)
        {
          let manualPlayer = manualPlayers[manualPlayerKey];
          let obj = manualPlayer;
          Object.assign(obj, { isManual: true, teamId: teamKey, key: manualPlayerKey, handicapsOriginal: this.handicapPrecision(team["handicapsOriginal"][manualPlayerKey]), tournamentHandicap: this.handicapPrecision(team["tournamentHandicap"][manualPlayerKey]) });
          if (groups["" + manualPlayerKey])
          {
            Object.assign(obj, { groupId: groups["" + manualPlayerKey] });
          }
          uniquePlayers.set(manualPlayerKey, obj)
        }

        for (let PlayerKey in players)
        {
          if ((!uniquePlayers.has(PlayerKey) || (uniquePlayers.has(PlayerKey) && tournamentPlayers[PlayerKey])))
          {
            let player = await this.apiService.object(`users/${PlayerKey}`);
            let obj = player;
            Object.assign(obj, { isManual: false, teamId: teamKey, key: PlayerKey, handicapsOriginal: this.handicapPrecision(team["handicapsOriginal"][PlayerKey]), tournamentHandicap: this.handicapPrecision(team["tournamentHandicap"][PlayerKey]) });
            if (groups["" + PlayerKey])
            {
              Object.assign(obj, {  groupId: groups["" + PlayerKey] });
            }
            uniquePlayers.set(PlayerKey, obj);
          }
        }
      }
      this.unallocatedEntries = Array.from(uniquePlayers.values());
      this.unallocatedEntriesOriginal = Array.from(uniquePlayers.values());
      this.unallocatedLength = this.unallocatedEntries.filter(element => { return !element.groupId }).length;
      
      await this.fetchGroups();
    }    
  }

  async onItemDrop(event: any, groupIndex: any, unallocatedEntryIndex) {
    if(this.groups[groupIndex].players && this.groups[groupIndex].players.length < this.groupSize)
    {
      this.imageLoader = true;
      this.groups[groupIndex].players.push(event.dragData);
      await this.fireDatabase.database.ref(`/tournament-fixtures/${this.tournamentId}/${event.dragData.teamId}/groups/${event.dragData.key}`).set(this.groups[groupIndex].groupId);
      await this.updateGroup(groupIndex); // manage remove or add entries from here
      await this.init();
      this.imageLoader = false;
    }
    else alert("Maximum Group size exceeded!");
  }

  handicapPrecision(handicap)
  {
    return handicap.toFixed(1);
  }
}
